<div class="titlebar">
  <h3>
    {{ "Template.CustomerDetailComponent.subHeader_customer" | translate }}
    @if (customer?.attributes?.['NAME']) {
      <span>: {{ customer?.attributes?.['NAME'] }}</span>
    }
  </h3>

  <div class="buttons">
    <button class="btn btn-secondary" [disabled]="loading['customer']" (click)="reload()">
      <fa-icon icon="arrow-rotate-right"></fa-icon>
    </button>
  </div>
</div>

@if (loading['customer']) {
  <fa-icon icon="spinner" animation="spin"></fa-icon>
}

@if (customer) {
  <div>
    <ul class="nav nav-tabs" ngbNav #tabs="ngbNav">
      <li class="nav-item" ngbNavItem>
        <a class="nav-link" ngbNavLink="#details">{{ "Template.CustomerDetailComponent.text_details" | translate }}</a>
        <ng-template ngbNavContent>
          <div class="tab-pane fade show" id="details" role="tabpanel">
            <h5 class="mb-2">{{ "Template.CustomerDetailComponent.subHeader_general" | translate }}:</h5>
            <div class="row">
              <div class="col-6 col-xs-12 px-4">
                <div class="row">
                  <div class="col-6">
                    <strong>{{ "Template.CustomerDetailComponent.text_customerNo" | translate }}:</strong>
                  </div>
                  <div class="col-6">
                    {{ customer | identification : "CUSTOMER_NO" }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <strong>{{ "Template.CustomerDetailComponent.text_name" | translate }}:</strong>
                  </div>
                  <div class="col-6">
                    {{ customer.attributes?.['NAME']}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <strong>{{ "Template.CustomerDetailComponent.text_active" | translate }}:</strong>
                  </div>
                  <div class="col-6">
                    @if (customer.enabled) {
                      <span>{{ "Template.CustomerDetailComponent.text_yes" | translate }}</span>
                    }
                    @if (!customer.enabled) {
                      <strong class="text-danger">
                        {{ "Template.CustomerDetailComponent.text_no" | translate }}
                        <fa-icon icon="exclamation-triangle"></fa-icon>
                      </strong>
                    }
                  </div>
                </div>
              </div>
              <div class="col-6 col-xs-12">
                <button class="btn btn-secondary d-block w-100 mb-2" (click)="changeCustomerName()">
                  {{ "Template.CustomerDetailComponent.btn_changeCompanyName" | translate }}
                </button>
                @if (customer.enabled) {
                  <button class="btn btn-warning d-block w-100" (click)="toggleCustomer(false)">{{ "Template.CustomerDetailComponent.btn_disable" | translate }}</button>
                }
                @if (!customer.enabled) {
                  <button class="btn btn-success d-block w-100" (click)="toggleCustomer(true)">{{ "Template.CustomerDetailComponent.btn_enable" | translate }}</button>
                }
              </div>
            </div>
            <hr />
            <!-- child component -->
            @if (customer) {
              <app-employees [isCustomer]="true" [party]="customer"></app-employees>
            }
          </div>
        </ng-template>
      </li>
      <li class="nav-item" ngbNavItem>
        <a class="nav-link" ngbNavLink="#accesses">{{ "Template.CustomerDetailComponent.btn_editAccesses" | translate }}</a>
        <ng-template ngbNavContent>
          <div class="tab-pane fade show" id="accesses" role="tabpanel">
            <h5 class="mb-2">{{ "Template.CustomerDetailComponent.subHeader_accesses" | translate }}:</h5>
            <form [formGroup]="customerForm" novalidate>
              <div class="row" formArrayName="dataStreamGroups">
                <div class="col-12 ps-4">
                  @for (dataStreamGroupControls of getFormArrayControls('dataStreamGroups'); track dataStreamGroupControls; let i = $index) {
                    <div class="form-check" [formGroupName]="i">
                      <input class="form-check-input" type="checkbox" [id]="'dsg_' + i" formControlName="enabled" />
                      <label class="form-check-label" [for]="'dsg_' + i">
                        {{ dataStreamGroupControls.value.name }}
                      </label>
                    </div>
                  }
                </div>
                <div class="col-12 col-md-6 col-lg-4 ps-4">
                  @if (!customerForm.get('editingDataStreamGroups')!.value) {
                    <button class="btn btn-secondary btn-sm d-block w-100 my-1 px-5" (click)="showForm({ controls: getFormArrayControls('dataStreamGroups') }, customer.dataStreamGroups, customerForm.get('editingDataStreamGroups'))">
                      <fa-icon icon="pencil-alt" class="me-1"></fa-icon>
                      <span>{{ "Template.CustomerDetailComponent.btn_editAccesses" | translate }}</span>
                    </button>
                  }
                  <!-- Edit Form Buttons -->
                  @if (customerForm.get('editingDataStreamGroups')!.value) {
                    <button class="btn btn-outline-danger btn-sm d-block w-100 mt-2 px-5" (click)="showForm({ controls: getFormArrayControls('dataStreamGroups') }, customer.dataStreamGroups, customerForm.get('editingDataStreamGroups'))">
                      <fa-icon icon="circle-xmark" class="me-1"></fa-icon>
                      <span>{{ "Common.btn_cancel" | translate }}</span>
                    </button>
                  }
                  @if (customerForm.get('editingDataStreamGroups')!.value) {
                    <button class="btn btn-success btn-sm d-block w-100 mt-2" (click)="saveDataStreamGroupAccesses()">
                      <fa-icon icon="check" class="me-1"></fa-icon>
                      <span> {{ "Template.CustomerDetailComponent.btn_saveAccesses" | translate }}</span>
                    </button>
                  }
                </div>
              </div>
            </form>
            @if (customer.dataStreamGroups && customer.dataStreamGroups.length) {
              <div>
                <hr />
                <h5>{{ "Template.CustomerDetailComponent.subHeader_datastreamAccesses" | translate }}:</h5>
                @for (dataStreamGroup of customer.dataStreamGroups; track dataStreamGroup) {
                  <div class="mb-4 ps-2">
                    <h6 class="mt-3">{{ dataStreamGroup.name }}</h6>
                    <div class="ps-2">
                      <app-data-stream-overview [dataStreamGroup]="dataStreamGroup" [employerPartyId]="customer.partyId"></app-data-stream-overview>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </ng-template>
      </li>
    </ul>
    <div class="tab-content" [ngbNavOutlet]="tabs"></div>
  </div>
}
